import { Spacer } from '@heroui/react';
import { DarkModeToggle } from '@milestone-portal/ui/DarkModeToggle/DarkModeToggle';
import { LanguageMenu } from '@milestone-portal/ui/LanguageMenu/LanguageMenu';

export function BasicActionBar() {
  return (
    <div className="flex">
      <LanguageMenu isIconOnly />
      <Spacer x={2} />
      <DarkModeToggle />
    </div>
  );
}
